import React from 'react';
// GoogleIcon removed — now using generic SSO login

const API = process.env.REACT_APP_API_URL || '';

const s = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #0F1629 0%, #0D2137 50%, #0F1629 100%)',
    position: 'relative', overflow: 'hidden',
  },
  grid: {
    position: 'absolute', inset: 0,
    backgroundImage: 'linear-gradient(#1E2D4F22 1px, transparent 1px), linear-gradient(90deg, #1E2D4F22 1px, transparent 1px)',
    backgroundSize: '60px 60px',
  },
  card: {
    position: 'relative', zIndex: 1,
    background: 'rgba(30,45,79,0.6)', backdropFilter: 'blur(20px)',
    border: '1px solid rgba(0,194,168,0.2)', borderRadius: '24px',
    padding: '56px 48px', width: '100%', maxWidth: '400px', textAlign: 'center',
    boxShadow: '0 32px 80px rgba(0,0,0,0.5)',
  },
  title: { fontFamily: 'Space Grotesk, sans-serif', fontSize: '28px', fontWeight: 700, color: '#F0F4FF', marginBottom: '8px' },
  subtitle: { fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#5B7BA8', lineHeight: 1.6, marginBottom: '40px' },
  btn: {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
    width: '100%', padding: '14px 24px',
    background: 'linear-gradient(135deg, #00C2A8, #00A090)',
    border: 'none', borderRadius: '12px', color: '#0F1629',
    fontFamily: 'Space Grotesk, sans-serif', fontWeight: 600, fontSize: '15px',
    cursor: 'pointer', boxShadow: '0 8px 32px rgba(0,194,168,0.3)',
    textDecoration: 'none',
  },
};

export default function LoginPage() {
  const error = new URLSearchParams(window.location.search).get('error');

  return (
    <div style={s.page}>
      <div style={s.grid} />
      <div style={s.card}>
        <div style={{ marginBottom: '28px' }}>
          <svg width="64" height="64" viewBox="0 0 96 96" fill="none">
            <path d="M48 8L16 22V46C16 63.2 30 79.1 48 84C66 79.1 80 63.2 80 46V22L48 8Z"
              fill="rgba(0,194,168,0.15)" stroke="#00C2A8" strokeWidth="2"/>
            <path d="M36 48L44 56L60 40" stroke="#00C2A8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h1 style={s.title}>DMARC Shield</h1>
        <p style={s.subtitle}>Sign in with your Google Workspace account to access the dashboard.</p>

        {error && (
          <div style={{ background:'rgba(232,65,90,0.1)', border:'1px solid rgba(232,65,90,0.3)', borderRadius:'8px', padding:'10px 14px', color:'#E8415A', fontSize:'13px', marginBottom:'20px', fontFamily:'Inter' }}>
            Authentication failed. Please try again.
          </div>
        )}

        <a href={`${API}/auth/saml`} style={s.btn}>
          Sign in with SSO
        </a>
      </div>
    </div>
  );
}

